'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('../../../shared/prop-types');

var _FollowUserLink = require('../FollowUserLink');

var _FollowUserLink2 = _interopRequireDefault(_FollowUserLink);

var _Uniform = require('../../Uniform');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoLink = function (_PureComponent) {
  _inherits(VideoLink, _PureComponent);

  function VideoLink() {
    _classCallCheck(this, VideoLink);

    return _possibleConstructorReturn(this, (VideoLink.__proto__ || Object.getPrototypeOf(VideoLink)).apply(this, arguments));
  }

  _createClass(VideoLink, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'video-link' },
          _react2.default.createElement(
            'div',
            { className: 'feedattachments' },
            _react2.default.createElement(
              'div',
              { className: 'feeditem-link', onClick: this.props.onClick },
              _react2.default.createElement(
                'a',
                { href: this.props.link.url, className: 'btn-video' },
                _react2.default.createElement(
                  'div',
                  { className: 'content' },
                  _react2.default.createElement(
                    _Uniform.CardMedia,
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'media-container' },
                      _react2.default.createElement(
                        'div',
                        { className: 'image-container' },
                        _react2.default.createElement(
                          'div',
                          { className: 'image-border' },
                          _react2.default.createElement('img', { src: this.props.thumbnail.url })
                        ),
                        _react2.default.createElement('div', { className: 'image-overlay border-only' }),
                        this.props.title ? _react2.default.createElement('div', { className: 'image-overlay' }) : null
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'content-description' },
                    this.props.title ? _react2.default.createElement(
                      _Uniform.Subhead,
                      { className: 'uni-margin--one--top' },
                      this.props.title
                    ) : null,
                    this.props.subtitle ? _react2.default.createElement(
                      _Uniform.Text,
                      { level: 'small', color: 'subtle', isTight: true, className: 'uni-margin--half--top' },
                      this.props.subtitle
                    ) : null
                  )
                )
              )
            )
          )
        ),
        this.props.includeFollowButton && this.props.relatedFeedUser && _react2.default.createElement(_FollowUserLink2.default, {
          currentUserId: this.props.currentUserId,
          feedUser: this.props.relatedFeedUser
        })
      );
    }
  }]);

  return VideoLink;
}(_react.PureComponent);

VideoLink.propTypes = {
  title: _react.PropTypes.string,
  subtitle: _react.PropTypes.string,
  link: _react.PropTypes.shape({
    url: _react.PropTypes.string.isRequired
  }).isRequired,
  thumbnail: _react.PropTypes.shape({
    url: _react.PropTypes.string.isRequired
  }),
  currentUserId: _react.PropTypes.string,
  includeFollowButton: _react.PropTypes.bool,
  relatedFeedUser: _propTypes.FeedUser,
  onClick: _react.PropTypes.func
};
exports.default = VideoLink;